module.exports = __webpack_public_path__ + "img/thumbnail_Takin_f_normal.413a749d.png";